function AppRun(
  Subscriber,
  ApiService,
  AppAuthFactory,
  LoopBackAuthGreenback,
  $rootScope,
  $transitions,
  $location,
  $state,
  $window) {
  'ngInject';

  const locationSearch = $location.search();

  let currentRoute = false;

  $transitions.onSuccess({}, (trans) => {
    currentRoute = trans.to().name;
    $window.scrollTo(0, 0);
  });

  $window.ga('create', 'UA-80733549-3', 'auto');

  $rootScope.$on('$stateChangeSuccess', function (event) {
    $window.ga('send', 'pageview', $location.path());
  });

  ApiService.checkGreenbackConnection().then(function () {
    console.log('ApiService.checkGreenbackConnection success');
    ApiService.checkAdvertisingConnection().then(function() {
      console.log('ApiService.checkAdvertisingConnection success');
    })
    .catch(function (err) {
      console.log('ApiService.checkAdvertisingConnection err: ' + err);
      $state.go('error.500', {errMsg: "There was an error connecting to our remote servers. Please check your intenet connection. If the error persists, select Report Error and let us help you resolve the issue! (R502ADV)"});
    });
  })
  .catch(function(err) {
    console.log('ApiService.checkGreenbackConnection err: ' + err);
    $state.go('error.500', {errMsg: "Please check your intenet connection. If the error persists, select Report Error and let us help you resolve the issue! (R502GBK)"});
  });

  $transitions.onStart({}, (trans) => {

    if(trans.to().name == currentRoute) return;

    const routeSegments = trans.to().name.split('.');

    let topLevelRoute = routeSegments[0];

    if(routeSegments[1]) {
      topLevelRoute += `.${routeSegments[1]}`;
    }

    console.log(`Request for ${trans.to().name} initiated check for top level route: ${topLevelRoute}`);

    const infoStates = [
      "download",
      "help.join",
      "help.direct",
      "help.loading",
      "faq",
      "terms.web",
      "terms.mobile",
      "error.500",
      "error.404",
      "error.stripe",
      "error.payment",
      "error.paypal",
      "error.ipn",
      "error.echeck"
    ];

    //list of routes accessible without being authenticated
    const isProtectedState = ! [
      "logout",
      "login.withemail",
      "login.verified",
      "login.renewal",
      "join.setup",
      "join.setupkeycause",
      "join.from-referral",
      "join.from-referral-success",
      "join.setup-referred-by",
      "join.setup-reconvene",//?
      "join.verify",
      "join.receipt",
      "join.receipt-stripe",
      "password.forgot",
      "password.forgot-resend",
      "password.reset",
      "password.reset-success",
      "confirm_deletion",
      ...infoStates
    ].includes(topLevelRoute);

    if(topLevelRoute !== "login" && isProtectedState && !Subscriber.isAuthenticated()) {
      console.log('__AppRun__: 1');
      console.log('Error: 403');
      $state.go('login');
    }
    else if(Subscriber.isAuthenticated() &&
        !["logout", ...infoStates].includes(topLevelRoute)) {
      console.log('__AppRun__: 2');
      AppAuthFactory.getCurrentUser((err, currentUser) => {
        console.log(err, currentUser, topLevelRoute);
        //do not perform rerouting logic if they are midway
        //through these registration process steps
        //or they are on the dashboard
        if(![
          "join.memberkeycause",
          "join.selectpayment",
          "join.receipt",
          "join.receipt-stripe",
          "join.setup-reconvene",//?
          "join.verify",//?
          "confirm_deletion",
          "login",
          //not join speicifc, can visit while logged in with active subscription
          "login.withemail",
          "login.renewal",
          "join.renewal",
          "join.renewalkey",
          "join.renewalselectpayment"
        ].includes(topLevelRoute) &&
          !topLevelRoute.includes("dashboard")) {
          console.log('__AppRun__: 2.a');
          _loginRouting(currentUser, () => {
            $state.go("dashboard.home");
          });
        }
        else if(topLevelRoute.includes("dashboard")) {
          console.log('__AppRun__: 2.b');
          _loginRouting(currentUser);
        }
      });
    }
    else {
      console.log('__AppRun__: 3');
    }
  });

  function _loginRouting(currentUser, isAllowedCb) {

    if(currentUser && currentUser.subscription && currentUser.subscription.cause) {
      console.log("loginRouting: __isAllowed__");
      isAllowedCb && isAllowedCb();
    }
    //if the current user has an account but no associated cause
    else if(currentUser && (!currentUser.subscription || currentUser.subscription && !currentUser.subscription.cause)) {
      console.log("redirecting to join.memberkeycause");
      $state.go('join.memberkeycause');
    }
  }

}

export default AppRun;



// WEBPACK FOOTER //
// ./js/config/app.run.js